import { Routes } from "@angular/router";
import { AppLayout } from "./layouts/app-layout";
import { AuthLayout } from "./layouts/auth-layout";
import { AuthGuard } from "./core/guards/auth.guard";

export const routes: Routes = [
  {
    path: 'reference-availability/:workspaceId/:token',
    loadComponent: () =>
      import('./modules/crm/pages/references/reference-availability-page.component').then(
        (m) => m.ReferenceAvailabilityPageComponent,
      ),
    title: 'Reference availability',
  },
  {
    path: 'forms/:wid/:id',
    loadComponent: () =>
      import('./modules/marketing/pages/forms/public-form/public-form-page.component').then(
        (m) => m.PublicFormPageComponent,
      ),
    title: 'Form',
  },
  {
    path: 'dashboards/public/export/:exportToken',
    loadComponent: () =>
      import('./modules/custom-dashboards/pages/custom-dashboard/custom-dashboard.component').then(
        (m) => m.CustomDashboardComponent,
      ),
    data: { publicExportMode: true },
    title: 'Dashboard Export',
  },
  {
    path: 'dashboards/public/:workspaceId/:shareToken',
    loadComponent: () =>
      import('./modules/custom-dashboards/pages/custom-dashboard/custom-dashboard.component').then(
        (m) => m.CustomDashboardComponent,
      ),
    data: { publicShareMode: true },
    title: 'Shared Dashboard',
  },
  {
    path: 'campaign-unsubscribe/:token',
    loadComponent: () =>
      import(
        './modules/marketing/pages/campaign-unsubscribe/public-campaign-unsubscribe-page.component'
      ).then((m) => m.PublicCampaignUnsubscribePageComponent),
    title: 'Unsubscribe',
  },
  {
    path: 'auth',
    component: AuthLayout,
    loadChildren: () => import('./modules/auth/auth-module').then(m => m.AuthModule)
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./modules/onboarding/onboarding.module').then(m => m.OnboardingModule)
  },
  {
    path: "",
    component: AppLayout,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        loadComponent: () =>
          import('./core/oauth-root-redirect/oauth-root-redirect.component').then(
            (m) => m.OAuthRootRedirectComponent,
          ),
      },
      {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard/dashboard-module').then(m => m.DashboardModule)
      },
      {
        path: 'dashboards',
        loadChildren: () =>
          import('./modules/custom-dashboards/custom-dashboards.routes').then(
            (m) => m.CUSTOM_DASHBOARDS_ROUTES,
          ),
      },
      {
        path: 'ai-assistant',
        loadChildren: () => import('./modules/ai-copilot/ai-copilot-module').then(m => m.AiCopilotModule),
      },
      {
        path: 'crm',
        loadChildren: () => import('./modules/crm/crm-module').then(m => m.CrmModule)
      },
      // Tasks are served under `activities` (`/activities/tasks`, `/activities/tasks/:id`).
      // Keeping a duplicate `/tasks` tree was redundant with sidebar + in-app navigation.
      // {
      //   path: 'tasks',
      //   children: [
      //     {
      //       path: '',
      //       loadComponent: () =>
      //         import('./modules/activities/pages/tasks/tasks.component').then((m) => m.TasksComponent),
      //       title: 'Tasks',
      //     },
      //     {
      //       path: ':id',
      //       loadComponent: () =>
      //         import('./modules/activities/pages/tasks/detail/task-detail.component').then((m) => m.TaskDetailComponent),
      //       title: 'Task',
      //     },
      //   ],
      // },
      {
        path: 'activities',
        loadChildren: () => import('./modules/activities/activities-module').then(m => m.ActivitiesModule)
      },
      {
        path: 'whatsapp',
        loadChildren: () =>
          import('./modules/whatsapp-inbox/whatsapp-inbox.routes').then(
            (m) => m.WHATSAPP_INBOX_ROUTES,
          ),
      },
      {
        path: 'marketing',
        loadChildren: () => import('./modules/marketing/marketing-module').then(m => m.MarketingModule)
      },
      {
        path: 'reporting',
        loadChildren: () =>
          import('./modules/reporting/reporting.routes').then((m) => m.REPORTING_ROUTES),
      },
      {
        path: 'enrichment-list',
        title: 'Enrichment List',
        loadComponent: () =>
          import('./pages/enrichment-list/enrichment-list.page').then((m) => m.EnrichmentListPage),
      },
      {
        path: 'data-enrichment',
        loadChildren: () =>
          import('./modules/data-enrichment/data-enrichment-module').then((m) => m.DataEnrichmentModule),
      },
      {
        path: 'workflows',
        loadChildren: () =>
          import('./pages/workflows/workflows.routes').then((m) => m.WORKFLOW_ROUTES),
      },
      {
        path: 'ai-studio',
        loadChildren: () => import('./modules/ai-studio/ai-studio-module').then((m) => m.AiStudioModule),
      },
      {
        path: 'settings',
        loadChildren: () => import('./modules/settings/settings.routes').then(m => m.SETTINGS_ROUTES)
      },
      {
        path: 'oauth/consent',
        loadComponent: () =>
          import('./pages/oauth/oauth-consent.component').then((m) => m.OAuthConsentComponent),
        title: 'Authorize App',
      },
      {
        path: 'subscription',
        loadChildren: () => import('./modules/subscription/subscription.routes').then((m) => m.SUBSCRIPTION_ROUTES),
      },
      {
        path: 'plan-bills',
        loadChildren: () =>
          import('./modules/plan-billing/plan-billing.routes').then((m) => m.PLAN_BILLING_ROUTES),
      },
      {
        path: 'help-center',
        loadChildren: () => import('./modules/help-center/help-center.routes').then(m => m.HELP_CENTER_ROUTES)
      },
      {
        path: 'changelog',
        loadChildren: () =>
          import('./modules/changelog/changelog.routes').then((m) => m.CHANGELOG_ROUTES),
      },
      {
        path: 'notification-center',
        loadChildren: () =>
          import('./pages/notification-center/notification-center.routes').then(
            (m) => m.NOTIFICATION_CENTER_ROUTES,
          ),
      },
    ],
  },
];
